<template>
  <div>
    <!-- <ReportInterpretation :componentId="studentId" :componentName="componentName"></ReportInterpretation> -->
    <ReportInterpretation2 :componentId="studentId" :componentName="componentName"></ReportInterpretation2>
    
  </div>
</template>

<script>
// import ReportInterpretation from '@/views/consultant/student/new/main/firstInterview/firstInterviewPartB'
import ReportInterpretation2 from '@/views/consultant/student/new/main/firstInterview/firstInterviewPartB_2'
export default {
  name: "report",
  data(){
    let names=JSON.parse(sessionStorage.getItem('mineStudentData'))
    return{
      studentId:sessionStorage.getItem('myStudentStudentId'),
      componentName:names&&names.name||''
    }
  },
  mounted(){
    
  },
  components:{ReportInterpretation2}
}
</script>

<style scoped>

</style>